module.exports = __webpack_public_path__ + "static/img/posture_assis_debout.a5bb620.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imageTests/posture_assis_debout.png
// module id = MDc/
// module chunks = 1